import React, { useEffect, useState, useMemo } from 'react'
import usePageLoaded from '../../hooks/usePageLoaded'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import { ContributionType, StatsType } from '../../store/contributions/contributionsTypings'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { A11y, Scrollbar } from 'swiper'

import MonthLink from './materials/monthLink/monthLink'
import ArchiveContributionPreview from './materials/ArchiveContributionPreview/ArchiveContributionPreview'

// import { formikValuesToApiConvertor } from '../index/indexDefaultComponent'
import { clearArchivesList, fetchArchiveContributions } from '../../store/archive/archiveSlice'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import moment from 'moment-mini'
import paths from '../../paths'

import './swiper.sass'
import useProtectImages from '../../hooks/useProtectImages'
import Button from '../../components/ui/button'
import { Trans, useTranslation } from 'react-i18next'
import PaginationLoader from '../../components/ui/paginationLoader/PaginationLoader'

import { fetchContributionsStat } from '../../store/contributions/contributionsSlice'
import { monthList } from '../../constants/months'
import { META } from '../../constants/meta'
import { getLangFromPath } from '../../i18next'
import { Helmet } from 'react-helmet'
import Pagination from 'rsuite/Pagination'
import { PaginationArchiveLink } from '../../components/ui/paginationLink/PaginationLink'
import cls from './archive.module.sass'
import './archive.sass'

const AMOUNT_OF_CONTRIBUTIONS_ON_PAGE = 20

const initialValues = () => {
    return {
        material: 0,
        gender: 0,
        certified: 0,
        free: 0,
        dateFrom: '2003/09/30',
        dateTo: moment().format('YYYY/MM/DD'),
        periodToSend: (() =>
            moment().subtract(1, 'years').format('DD/MM/YYYY') + '-' + moment().format('DD/MM/YYYY'))(),
        period: 0,
        limit: AMOUNT_OF_CONTRIBUTIONS_ON_PAGE
    }
}

const API_MATERIAL_FORMATTER = ['photo-and-video', 'photo', 'video']
const API_GENDER_FORMATTER = ['', 'female-or-couple', 'male']
// @ts-ignore
export const formikValuesToApiConvertor = (value, page = 1) => {
    return {
        material: API_MATERIAL_FORMATTER[value.material],
        gender: API_GENDER_FORMATTER[value.gender],
        certified: value.certified,
        free: value.free,
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
        p: page,
        timestamp: Number(new Date()),
        limit: AMOUNT_OF_CONTRIBUTIONS_ON_PAGE
    }
}

SwiperCore.use([A11y, Scrollbar])

const Archive = ({ match }: { match: unknown }) => {
    // @ts-ignore
    const { year } = match.params
    // @ts-ignore
    const { month } = match.params

    usePageLoaded()

    const dispatch = useDispatch()
    const location = useLocation()
    const [t] = useTranslation()

    const list = useSelector<RootState, ContributionType[]>((state) => state.archive.list)
    const isLoading = useSelector<RootState, boolean>((state) => state.archive.isLoading)
    const total_count = useSelector<RootState, number>((state) => state.archive.total_count)
    const stats = useSelector<RootState, StatsType | null>((state) => state.contributions.stats)

    const [swiperRef, setSwiperRef] = useState(null)

    const getCurrentPage = () => new URLSearchParams(location.search).get('p')
    const [currentPage, setCurrentPage] = useState(getCurrentPage() || 1)

    const yearFromPath = year
    const currentYear = moment().format('YYYY')

    useProtectImages(list.length)

    let months = new Array(12).fill('1').map((n, i) => i)
    if (year === moment().format('YYYY')) {
        months = months.slice(0, Number(moment().format('MM')))
    }

    const currentInitialValues = useMemo(() => {
        const currentValues = initialValues()

        currentValues.dateFrom = `${year}/${month}/01`
        currentValues.dateTo = `${year}/${month}/31`
        currentValues.periodToSend = `${year}/${month}/1-${year}/${month}/31}`
        return currentValues
    }, [month, year])

    useEffect(() => {
        setCurrentPage(getCurrentPage() || 1)
        if (list.length > 0) dispatch(clearArchivesList())
    }, [location.search])

    useEffect(() => {
        if (swiperRef) swiperRef.slideTo(month - 1)
    }, [month])

    useEffect(() => {
        const loadNextPage = async () => {
            if (currentPage > 0)
                await dispatch(
                    fetchArchiveContributions(formikValuesToApiConvertor(currentInitialValues, +currentPage))
                )
        }
        loadNextPage()
    }, [currentPage])

    return (
        <div
            className="pageContent"
            style={{
                margin: '0 auto',
                maxWidth: '1360px',
                padding: '90px 27px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px'
            }}
        >
            <Helmet>
                <title>
                    {META.archive[getLangFromPath(location.pathname)].title
                        .replace('{MONTH}', t(monthList[month]))
                        .replace('{YEAR}', year)
                        .replace('{CONTRIBUTIONS}', stats.contribution_counter ? stats.contribution_counter : 0)}
                </title>
                <meta
                    name="description"
                    content={META.archive[getLangFromPath(location.pathname)].description
                        .replace('{MONTH}', t(monthList[month]))
                        .replace('{YEAR}', year)}
                />
            </Helmet>
            <div className={cls['year']}>
                <Link
                    // to={`${Number(yearFromPath) - 1}-12`}
                    to={createLocalizedPath(paths.archive.toPath({ year: yearFromPath - 1, month: 12 }))}
                    className={`${
                        Number(yearFromPath) < 2003 ? `${cls['prevYear']} ${cls['lastYear']}` : cls['prevYear']
                    }`}
                    onClick={() => {
                        setCurrentPage(1)
                        dispatch(clearArchivesList())
                    }}
                >
                    <img
                        src={require('./../../assets/ic-arrowPagination.svg')}
                        width={16}
                        height={16}
                        alt={'Предыдущий год'}
                    />
                </Link>
                <span>{yearFromPath}</span>
                <Link
                    to={createLocalizedPath(paths.archive.toPath({ year: Number(yearFromPath) + 1, month: 1 }))}
                    className={`${cls['nextYear']} ${yearFromPath == currentYear ? cls['lastYear'] : ''}`}
                    onClick={() => {
                        setCurrentPage(1)
                        dispatch(clearArchivesList())
                    }}
                >
                    <img
                        src={require('./../../assets/ic-arrowPagination.svg')}
                        width={16}
                        height={16}
                        alt={'Следующий год'}
                    />
                </Link>
            </div>
            <div className={'monthsBlockSwiper'}>
                <Swiper
                    onSwiper={setSwiperRef}
                    spaceBetween={16}
                    grabCursor={true}
                    scrollbar={{
                        hide: false
                    }}
                    // modules={[A11y, Scrollbar]}
                    slidesPerView={'auto'}
                    initialSlide={month - 1}
                >
                    {months.map((month) => (
                        <SwiperSlide key={month}>
                            <MonthLink
                                href={`${createLocalizedPath(paths.archive.toPath({ year: year, month: month + 1 }))}`}
                                label={t(monthList[month])}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className={cls['archiveInfo']}>
                <h1>
                    <Trans i18nKey={'Archive header'} values={{ month: t(monthList[month - 1]), year, total_count }}>
                        Archives - {month} {year} - {total_count} contributions
                    </Trans>
                </h1>
                <div>
                    <p>
                        {t(
                            'All photo and video contributions published since the creation of the site are in thearchives'
                        )}
                    </p>
                    <p>{t('Premium members have access to all sections of Bob Voyeur and the archives')}</p>
                    <p>
                        <Trans
                            i18nKey={'Archive counters'}
                            values={{
                                contribution_counter: stats.contribution_counter,
                                material_counter: stats.material_counter
                            }}
                        >
                            Au total {stats.contribution_counter} contributions avec {stats.material_counter} photos et
                            vidéos amateurs!
                        </Trans>
                    </p>
                </div>
            </div>

            {+total_count > 20 ? (
                <Pagination
                    limit={20}
                    // limitOptions={[20]}
                    maxButtons={10}
                    activePage={+currentPage}
                    linkAs={PaginationArchiveLink}
                    total={+total_count}
                />
            ) : (
                <></>
            )}

            <div className={cls['archiveList']}>
                {list.map((contribution: ContributionType) => (
                    <ArchiveContributionPreview contribution={contribution} key={contribution.id} />
                ))}
            </div>
            {isLoading ? (
                <PaginationLoader />
            ) : +total_count > 20 ? (
                <Pagination
                    limit={20}
                    // limitOptions={[20]}
                    maxButtons={10}
                    activePage={+currentPage}
                    linkAs={PaginationArchiveLink}
                    total={+total_count}
                />
            ) : (
                <></>
            )}
        </div>
    )
}

// @ts-ignore
Archive.getInitialProps = async ({ req, store, match, location }) => {
    const {
        params: { year, month }
    } = match

    const {
        archive: { list }
    } = store.getState()

    const page = req ? req.query.p : new URLSearchParams(location.search).get('p')

    if (!year || !month)
        return (() => {
            return { redirectTo: paths.archive.toPath({ year: moment().format('YYYY'), month: moment().format('MM') }) }
        })()

    if (!list.length) {
        const currentInitialValues = initialValues()

        currentInitialValues.dateFrom = `${year}/${month}/01`
        currentInitialValues.dateTo = `${year}/${month}/31`
        currentInitialValues.periodToSend = `${year}/${month}/1-${year}/${month}/31`

        await store.dispatch(fetchArchiveContributions(formikValuesToApiConvertor(currentInitialValues, page || 1)))
    }
    await store.dispatch(fetchContributionsStat())
}

export default Archive
